'use strict';

var toggleCtrl = [function() {
    var _this = this;
    this.id = Math.floor(Math.random() * 10000);

    this.onChange = function() {
        _this.toggleChange({
            itemId: _this.itemId || '',
            status: _this.status
        });
    };
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            status: '=',
            toggleChange: '&',
            itemId: '='
        },
        controller: toggleCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'toggle-directive/toggleDirective.html'
    };
};
